// styles
import { customStyled } from "styles/theme"

export const SReport = customStyled("div")(({ theme: { spacing, breakpoints } }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  margin: "0 auto",
  width: "437px",
  [breakpoints.down("xs")]: {
    padding: spacing(5),
    width: "100%",
  },
}))

export const SReportButtonWrapper = customStyled("div")(
  ({
    theme: {
      palette: { black },
      spacing,
      breakpoints,
    },
  }) => ({
    width: "100%",

    ".MuiButtonBase-root.Mui-disabled": {
      color: black.lacquer["200"],
      backgroundColor: black.lacquer["700"],
    },

    [breakpoints.down("xs")]: {
      position: "fixed",
      bottom: spacing(5),
      left: spacing(5),
      width: `calc(100% - ${spacing(5)} - ${spacing(5)})`,
    },
  })
)
